import React, { lazy } from 'react';
import { MapPin, Phone, Mail, Instagram, MessageCircle } from 'lucide-react';
import { SEOSchema } from '../components/SEOSchema';
import { useLanguage } from '../contexts/LanguageContext';
export function ContactPage() {
  const {
    t
  } = useLanguage();
  return <div className="pt-20 min-h-screen bg-white" data-id="element-646">
      <SEOSchema type="contact" title={t('Kontak | PT Graha Riau Gemilang', 'Contact Us | PT Graha Riau Gemilang')} description={t('Hubungi PT Graha Riau Gemilang untuk konsultasi properti, proyek perumahan, dan peluang investasi di Riau.', 'Contact PT Graha Riau Gemilang for property consultation, project inquiries, and investment opportunities in Riau.')} breadcrumbs={[{
      name: t('Beranda', 'Home'),
      url: 'https://grahariaugemilang.com/'
    }, {
      name: t('Kontak', 'Contact'),
      url: 'https://grahariaugemilang.com/kontak'
    }]} data-id="element-647" />

      <div className="bg-gray-900 text-white py-20" data-id="element-648">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-649">
          <h1 className="text-4xl font-bold mb-4" data-id="element-650">
            {t('Hubungi Kami', 'Contact Us')}
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-651">
            {t('Kami siap membantu mewujudkan properti impian Anda.', 'We are ready to help you realize your dream property.')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-652">
        <div className="max-w-4xl mx-auto" data-id="element-653">
          {/* Office Photo - without title */}
          <div className="mb-12" data-id="element-654">
            <div className="rounded-xl overflow-hidden shadow-premium-lg" data-id="element-655">
              <img src="https://cdn.magicpatterns.com/uploads/9Xm28KaLFmnTEqcYBohmkM/PT.-Graha-riau-gemilang_MSDL.jpg" alt="Kantor PT Graha Riau Gemilang" className="w-full h-auto object-cover" data-id="element-656" />
            </div>
          </div>

          {/* Contact Info */}
          <div className="mb-12" data-id="element-657">
            <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-658">
              {t('Informasi Kontak', 'Contact Information')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-659">
              <div className="flex items-start space-x-4" data-id="element-660">
                <div className="bg-red-50 p-3 rounded-lg text-[#C4161C]" data-id="element-661">
                  <MapPin className="w-6 h-6" data-id="element-662" />
                </div>
                <div data-id="element-663">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-664">
                    {t('Kantor Pusat', 'Head Office')}
                  </h3>
                  <p className="text-gray-600" data-id="element-665">
                    Jl. Tiung No. 16A, Kel. Kampung Melayu,
                    <br data-id="element-666" />
                    Kec. Sukajadi, Pekanbaru, Riau
                    <br data-id="element-667" />
                    Indonesia
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-668">
                <div className="bg-red-50 p-3 rounded-lg text-[#C4161C]" data-id="element-669">
                  <Phone className="w-6 h-6" data-id="element-670" />
                </div>
                <div data-id="element-671">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-672">
                    {t('Telepon', 'Phone')}
                  </h3>
                  <div className="flex flex-col space-y-1" data-id="element-673">
                    <a href="tel:+6276121493" className="text-gray-600 hover:text-[#C4161C] transition-colors" data-id="element-674">
                      0761-21493
                    </a>
                    <a href="tel:+6276147961" className="text-gray-600 hover:text-[#C4161C] transition-colors" data-id="element-675">
                      0761-47961
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-676">
                <div className="bg-red-50 p-3 rounded-lg text-[#C4161C]" data-id="element-677">
                  <Mail className="w-6 h-6" data-id="element-678" />
                </div>
                <div data-id="element-679">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-680">Email</h3>
                  <a href="mailto:grahariaugemilang@gmail.com" className="text-gray-600 hover:text-[#C4161C] transition-colors" data-id="element-681">
                    grahariaugemilang@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4" data-id="element-682">
                <div className="bg-red-50 p-3 rounded-lg text-[#C4161C]" data-id="element-683">
                  <Instagram className="w-6 h-6" data-id="element-684" />
                </div>
                <div data-id="element-685">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-686">Instagram</h3>
                  <a href="https://www.instagram.com/pt.grahariaugemilang/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#C4161C] transition-colors" data-id="element-687">
                    @pt.grahariaugemilang
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* WhatsApp Contact Cards */}
          <div className="mb-12" data-id="element-688">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-689">
              {t('Hubungi via WhatsApp', 'Contact via WhatsApp')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-690">
              <a href="https://wa.me/62817203456" target="_blank" rel="noopener noreferrer" className="flex items-center p-6 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border-2 border-green-200 hover:border-green-400 hover:shadow-lg transition-all duration-300 group" data-id="element-691">
                <div className="w-16 h-16 rounded-full bg-[#25D366] flex items-center justify-center text-white mr-4 group-hover:scale-110 transition-transform" data-id="element-692">
                  <MessageCircle className="w-8 h-8" data-id="element-693" />
                </div>
                <div data-id="element-694">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-695">
                    {t('WhatsApp 1', 'WhatsApp 1')}
                  </h3>
                  <p className="text-[#25D366] font-semibold" data-id="element-696">
                    +62 817-203-456
                  </p>
                  <p className="text-xs text-gray-600 mt-1" data-id="element-697">
                    {t('Klik untuk chat', 'Click to chat')}
                  </p>
                </div>
              </a>

              <a href="https://wa.me/6281365631901" target="_blank" rel="noopener noreferrer" className="flex items-center p-6 bg-gradient-to-r from-green-50 to-emerald-50 rounded-xl border-2 border-green-200 hover:border-green-400 hover:shadow-lg transition-all duration-300 group" data-id="element-698">
                <div className="w-16 h-16 rounded-full bg-[#25D366] flex items-center justify-center text-white mr-4 group-hover:scale-110 transition-transform" data-id="element-699">
                  <MessageCircle className="w-8 h-8" data-id="element-700" />
                </div>
                <div data-id="element-701">
                  <h3 className="font-bold text-gray-900 mb-1" data-id="element-702">
                    {t('WhatsApp 2', 'WhatsApp 2')}
                  </h3>
                  <p className="text-[#25D366] font-semibold" data-id="element-703">
                    +62 813-6563-1901
                  </p>
                  <p className="text-xs text-gray-600 mt-1" data-id="element-704">
                    {t('Klik untuk chat', 'Click to chat')}
                  </p>
                </div>
              </a>
            </div>
          </div>

          {/* Google Maps */}
          <div className="mt-12" data-id="element-705">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-706">
              {t('Lokasi Kantor', 'Office Location')}
            </h2>
            <div className="rounded-xl overflow-hidden shadow-lg" data-id="element-707">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.6647899999997!2d101.4347!3d0.5347!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc5a9a30dce1df7ac!2sPT.%20Graha%20Riau%20Gemilang!5e0!3m2!1sid!2sid!4v1234567890" width="100%" height="450" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title={t('Peta Lokasi Kantor PT Graha Riau Gemilang', 'PT Graha Riau Gemilang Office Location Map')} data-id="element-708"></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a href="https://wa.me/62817203456" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 group" aria-label="WhatsApp" data-id="element-709">
        <div className="relative" data-id="element-710">
          {/* Pulse animation */}
          <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-75" data-id="element-711"></div>

          {/* Main button */}
          <div className="relative w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center text-white shadow-2xl hover:bg-[#20BA5A] transition-all duration-300 hover:scale-110" data-id="element-712">
            <MessageCircle className="w-8 h-8" data-id="element-713" />
          </div>

          {/* Tooltip */}
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" data-id="element-714">
            {t('Chat WhatsApp', 'Chat WhatsApp')}
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-gray-900" data-id="element-715"></div>
          </div>
        </div>
      </a>
    </div>;
}